import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';

/*
  Generated class for the WalletProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WalletProvider {
  constructor(public http: HttpProvider) {
    console.log('Hello WalletProvider Provider');
  }

  getWalletStatus() {
    return this.http.hPost('/wallet/get_status');
  }

  switchFuncWallet(is_switch?: boolean) {
    return this.http.hPost('/wallet/switch', { switch: is_switch?1:0 });
  }

  getChatroomList() {
    return this.http.hPost('/wallet/get_chatroom_list',{keyword:''});
  }

  getMemberWallet(page, pagesize, chatroomname,keyword = null) {
    let params = {
      limit: pagesize,
      offset: page,
      keyword:keyword,
      chatroomname: chatroomname,
    };
    return this.http.hPost('/wallet/get_list_by_chatroomname', params);
  }

  getMemberNoWallet(page, pagesize, chatroom_id) {
    let params = {
      offset: page,
      limit: pagesize,
      chatroom_id: chatroom_id,
    };
    return this.http.hPost('/get_members_without_coin_wallet', params);
  }

  updataAWallet(wallet_id, address_text) {
    let params = {
      wallet_id: wallet_id,
      address_text: address_text,
    };
    return this.http.hPost('/update_a_coin_wallet', params);
  }

  deleteAWallet(wallet_id) {
    return this.http.hPost('/wallet/delete', { id: wallet_id });
  }

  searchMemberList(keyword, offset, limit) {
    let params = {
      keyword: keyword,
      offset: offset,
      limit: limit,
    };
    return this.http.hPost('/search_coin_wallet', params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/wallet/wallet.ts